module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point2_3-16eaf9141a0b4a87d854f28d58cc8b4e.jpg";